module.exports = __webpack_public_path__ + "img/speed_good.d086077e.svg";